import { SCREEN } from '../../utils/constants';

import { selectInterest } from '../actions/interestActions';
import {navigate } from './movePages';

export function interestListeners() {
    /* on select interest*/
    document
        .querySelectorAll('.interests__container .interest')
        .forEach((i) => {
            i.addEventListener('click', () => {
                const value = i.getAttribute('data-interest');
                selectInterest(value);
            });
        });

        /* On click enter */
    const screenInterests = document
        .querySelector('.screen--interests');

        if (screenInterests) {
        screenInterests.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' && !document
            .querySelector('.interestContinue__btn').classList.contains('disabled')) {
                document
                    .querySelector('.interestContinue__btn').click();
            }
        });
    }


    /* on click Continue after select interest */
    document
        .querySelector('.interestContinue__btn')
        .addEventListener('click', () => {
          navigate(SCREEN.FULL_NAME);
          setTimeout(() => {
            const fullNameInput = document.getElementById('fullName');
            if (fullNameInput !== document.activeElement) {
                fullNameInput.focus();
            }
          }, 500);
        });

}
